module.exports = __webpack_public_path__ + "static/media/vgg16.9e80a21e.avif";